namespace $ {

	class $shm_hitalama_map_widgets extends $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget ){ }

	export class $shm_hitalama_map extends $giper_baza_entity.with({

		Widgets: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widgets ),
		// Widgets: $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget ),

		Widget_by_name: $giper_baza_dict_to( $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ) ),
		
		Widgets_removed: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widgets ),

		Created_at: $giper_baza_atom_real,
		Changed_at: $giper_baza_atom_real,

		Access_level: $giper_baza_atom_text, //private, public_read, public_edit
		Version: $giper_baza_atom_real,

		Last_color: $giper_baza_atom_text,
		Last_font_size: $giper_baza_atom_real,

		Last_width: $giper_baza_atom_real,
		Last_height: $giper_baza_atom_real,

		Search_statistics: $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget_entity_form ),

		Files: $giper_baza_list_link.to( ()=> $shm_hitalama_file ),

		Tables: $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget_entity_table ),

		Charts: $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget_entity_chart ),

		Description: $giper_baza_atom_text,

		Presences: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_presence_dict ),

		Customs: $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget_entity_custom ),

		Slideshow_enabled: $giper_baza_atom_bool,
		Camera_locked: $giper_baza_atom_bool,
		Slideshow_frame: $giper_baza_atom_real,

		Backup_time: $giper_baza_atom_real,

		Store_json: $giper_baza_atom_dict,
		Journal_snapshots: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_journal_snapshots ),

	}){

		static access_level_to_ranks() {
			return {
				'private': [[ null, $giper_baza_rank_deny ]],
				'public_read': [[ null, $giper_baza_rank_read ]],
				'public_edit': [[ null, $giper_baza_rank_rule ]],
			}
		} 

		@ $mol_action
		static make_new( title: string, access_level: keyof ReturnType<typeof $shm_hitalama_map.access_level_to_ranks> ) {
			const ranks = this.access_level_to_ranks()[ access_level ] as any as $giper_baza_rank_preset
			const land = this.$.$giper_baza_glob.land_grab( ranks )
			const map = land.Data( $shm_hitalama_map )
			const time = ( new $mol_time_moment ).valueOf()
			map.title( title )
			map.Created_at(null)?.val( time )
			map.Changed_at(null)?.val( time )
			map.access_level( access_level )
			map.version( $shm_hitalama_map_migration.latest_version() )
			return map
		}

		@ $mol_action
		static make_fast( title: string ) {
			const land_make = ( this.$ as any ).$rise_baza_patch_land_make as
				| undefined
				| ( ( Pawn: typeof $giper_baza_pawn, context?: any )=> $giper_baza_land )
			
			if( !land_make ) return $mol_fail( new Error( '$rise_baza_patch_land_make is not available' ) )
			
			const land = land_make( $shm_hitalama_map, this.$ )
			const map = land.Data( $shm_hitalama_map )
			const time = ( new $mol_time_moment ).valueOf()
			map.title( title )
			map.Created_at(null)?.val( time )
			map.Changed_at(null)?.val( time )
			map.access_level( 'fast' )
			map.version( $shm_hitalama_map_migration.latest_version() )
			return map
		}

		@ $mol_mem_key
		temp_store( key: string, next?: any ) {
			$mol_wire_solid()
			return next
		}

		journal_snapshots() {
			return $shm_hitalama_map_journal_recorder.journal( this )
		}

		@ $mol_mem_key
		store( key: string, next?: any ) {
			const obj: any = this.Store_json(null)?.val() ?? {}
			if( next === undefined ) return obj[key]

			this.Store_json(null)?.val( {...obj, [key]: next} )
			return next
		}

		@ $mol_action
		store_async( key: string, next?: any ) {
			if( next === undefined ) return structuredClone( this.store( key ) )
			return this.store( key, next )
		}

		@ $mol_mem_key
		widget_by_link( ref: $giper_baza_link ) {
			return $giper_baza_glob.Pawn( ref, $shm_hitalama_map_widget )
		}
		
		@ $mol_mem_key
		widget( ref: string ) {
			try {
				return this.widget_by_link( new $giper_baza_link( ref ) )
			} catch (error) {
				const by_name = this.Widgets_list()?.remote_list().find( b => b.title() == ref )
				if( !by_name ) throw new Error(`Widget "${ref}" isn't exist (neither ref nor name)`)
				return by_name
			}
		}

		version( next?: number ) {
			return this.Version( next )?.val( next ) ?? 0
		}

		Widgets_list(auto?: null): $shm_hitalama_map_widgets | null {
			const slot = this.Widgets()
			const list = slot?.remote()
			if( list && typeof ( list as any ).remote_list === 'function' ) return list

			if( auto !== null ) return null

			const area = this.land().area_make()
			const fresh = $giper_baza_glob.Pawn( area.link(), $shm_hitalama_map_widgets )
			this.Widgets(null)?.remote( fresh )
			return fresh
		}
		Widgets_removed_list(auto?: null): $shm_hitalama_map_widgets | null {
			const slot = this.Widgets_removed()
			const list = slot?.remote()
			if( list && typeof ( list as any ).remote_list === 'function' ) return list

			if( auto !== null ) return null

			const area = this.land().area_make()
			const fresh = $giper_baza_glob.Pawn( area.link(), $shm_hitalama_map_widgets )
			this.Widgets_removed(null)?.remote( fresh )
			return fresh
		}
		
		widget_text( ref: string, next?: string ) {
			return this.widget( ref ).text( next )
		}
		
		widget_data( ref: string, next?: any ) {
			return this.widget( ref ).data( next )
		}

		widget_file( ref: string ) {
			const widget = this.widget( ref )
			const file = widget.File()?.remote()
			if( !file ) throw new Error( `No file for widget "${ widget.title() || ref }"` )
			return file
		}

		@ $mol_mem_key
		import_js_file_uri( file: $shm_hitalama_file ) {
			const blob = file.blob()
			if( !blob ) throw new Error( 'Файл не найден' )

			const js_blob = $shm_hitalama_map_widget_entity_app.archive( file )
				? $shm_hitalama_map_widget_entity_app.js_file_from( file )
				: new Blob( [ blob ], { type: 'text/javascript' } )
			return URL.createObjectURL( js_blob )
		}

		@ $mol_mem_key
		import_js_file( file: $shm_hitalama_file ) {
			return $mol_import.module( this.import_js_file_uri( file ) )
		}

		widget_value( ref: string, next?: any ) {
			const widget = this.widget( ref )
			
			const type = widget.type()
			switch (type) {
				case 'code':
				case 'code_js':
				case 'code_ts':
				case 'code_html':
				case 'code_sql': {
					if( next === undefined ) {
						const run_auto = this.widget_code_run_auto( widget )
						if( run_auto ) return run_auto()
					}
					break
				}
				case 'form_custom': {
					if( widget.Data_method()?.val() ) return widget.data( next )
					return widget.form_custom().object_current( next )
				}
				case 'table_novirt':
				case 'tabulator':
				case 'table': {
					const custom = widget.table().form_custom()
					if( custom ) return custom.objects()
	
					const head = widget.table_head()
					const rows = widget.table_rows()
					return rows.map( r => Object.fromEntries( head.map( (h, i)=> [ h, r[i] ] ) ) )
				}
				case 'autoview': {
					const data = widget.data() ?? {}
					if( next === undefined ) return data.value
					widget.data({ ... data, value: next })
					return next
				}
				case 'text': {
					if( next === undefined ) return widget.preprocessed()
					return widget.text(next)
				}
				case 'image': {
					return widget.Image()?.blob()
				}
				case 'file': {
					return widget.text()
				}
			}

			return this.execute( widget.code(), { [ '$' + 'arg' ]: next ?? {}, [ '$' + 'this_widget' ]: widget } )
		}

		widget_code_run_auto( widget: $shm_hitalama_map_widget ) {
			const runner = this.runtime().widget_runner( widget.link_str() )
			return ()=> runner.run_auto()
		}

		async widget_value_async( ref: string, next?: any ) {
			const widget = this.widget( ref )

			if( [ 'code', 'code_js', 'code_ts', 'code_html', 'code_sql' ].includes( widget.type() ) ) {
				const run_auto = this.widget_code_run_auto( widget )
				if( run_auto ) return run_auto()
			}

			if( ['form_custom','table','text','image','file'].includes( widget.type() ) ) {
				return this.widget_value( ref, next )
			}

			return await $mol_wire_async( this ).execute_action( widget.code(), { [ '$' + 'arg' ]: next ?? {}, [ '$' + 'this_widget' ]: widget } )
		}

		@ $mol_mem
		access_level( next?: string ){
			return this.Access_level(next)?.val( next ) ?? ''
		}

		@ $mol_mem
		slideshow_enabled( next?: boolean ){
			// if( next ) document.documentElement.requestFullscreen()
			// else if( next === false ) document.exitFullscreen()
			return this.Slideshow_enabled(next)?.val( next ) ?? false
		}
		
		@ $mol_mem
		camera_locked( next?: boolean ){
			return this.slideshow_enabled()
				|| this.Camera_locked(next)?.val( next )
				|| false
		}

		@ $mol_mem
		backup_time( next?: string ): string {
			if( next === undefined ) return String( this.Backup_time()?.val() || 5 )
			
			this.Backup_time(next)?.val( Number(next) )
			return next
		}

		slideshow_frame( next?: number ) {
			if( next !== undefined ) {
				if( next < 1 ) next = 1
				const max = this.viewport_frames().length
				if( next > max ) next = max
			}
			return this.Slideshow_frame(next)?.val(next) ?? 1
		}
		
		slideshow_frame_str() {
			return String(this.slideshow_frame())
		}

		@ $mol_mem
		viewport_frames_visible( next = true ) {
			return next
		}

		@ $mol_mem
		runtime() {
			$mol_wire_solid()
			return $shm_hitalama_map_runtime.make({
				map: ()=> this,
			})
		}

		@ $mol_mem
		method_runtime() {
			return $shm_hitalama_map_method_runtime.make({
				map: ()=> this,
			})
		}

		@ $mol_mem
		method_app() {
			return this.method_runtime().app()
		}

		@ $mol_mem
		method_source() {
			return this.method_runtime().source()
		}

		extract_reactive_deps( text: string ){
			return this.runtime().extract_reactive_deps( text )
		}

		prepare_html( text: string ) {
			return this.runtime().prepare_html( text )
		}

		execute( code: string, context?: Record< string, any > ) {
			return this.runtime().execute( code, context )
		}

		@ $mol_action
		execute_action( code: string, context?: Record< string, any > ) {
			return this.runtime().execute_action( code, context )
		}

		@ $mol_action
		make_public() {
			this.land().give( null, $giper_baza_rank_read )
		}

		@ $mol_action
		now() {
			return new $mol_time_moment
		}

		@ $mol_action
		widget_add(
			type: $shm_hitalama_map_widget_def_type_name,
			pos: readonly [number, number] | readonly number[] = [0,0],
			width = 200, height = 100,
			name?: string,
			text = '',
		) {
			if( name ) {
				const by_name = this.Widget_by_name(null)?.key( name )
				if( by_name ) return by_name.remote()
				
				// try {
				// 	const by_link = this.widget( name_or_link )
				// 	if( by_link ) return by_link
				// } catch (error) {
				// 	console.error( error )
				// }
			}

			const widget = this.Widgets_list(null)?.make( this.land() )
			
			let title = name
			if( !title ) {
				const default_title = $shm_hitalama_map_widget_def_titles[ type ] || type
				const titles = this.Widgets_list(null)?.remote_list().map( w => w.title() ) ?? []
				title = $shm_hitalama_inc_name( titles, default_title )
				// 	title = widget?.link().toString()!
			}
			const time = this.now().valueOf()
			widget?.Created_at(null)?.val( time )
			this.Changed_at(null)?.val( time )

			this.Widget_by_name(null)?.key( title, 'auto' ).remote( widget )

			widget?.text_crdt_disabled( true )

			widget?.Map(null)?.remote( this )
			widget?.render_data_patch({
				title,
				type,
				text,
				body_x: pos[0],
				body_y: pos[1],
				right_edge_x: width,
				bottom_edge_y: height,
				opacity: 1,
			})
			if( [ 'table', 'table_novirt', 'tabulator' ].includes( type ) ) {
				widget?.table().Map( null )?.remote( this )
			}
			if( [ 'chart', 'echarts' ].includes( type ) ) {
				widget?.table().Map( null )?.remote( this )
				widget?.chart().Widget( null )?.remote( widget )
			}
			if( type === 'group' ) {
				this.border_preset( widget, 'var(--mol_theme_line)', 2, 'dashed' )
			}
			return widget
		}

		border_preset(
			widget: $shm_hitalama_map_widget | null | undefined,
			color: string,
			width: number,
			style: string,
		) {
			widget?.Border_color(null)?.val( color )
			widget?.Border_width(null)?.val( width )
			widget?.Border_style(null)?.val( style )
		}

		@ $mol_action
		widget_cut( link: $giper_baza_link ) {
			const widget = this.widget_by_link(link)

			this.widget_detach( link )
			widget.container_widget( null )

			widget.widgets().forEach( w => this.widget_cut( w.link() ) )

			if( widget.type() == 'file' ) {
				const file_link = widget.File()?.remote()?.link()
				if( file_link ) this.Files(null)?.cut( file_link )
			}

			this.Widgets_list(null)?.cut( link )
			this.Widgets_removed_list(null)?.add( link )
		}

		@ $mol_action
		widget_detach( link: $giper_baza_link ) {
			const containers = [
				...( this.Widgets_list()?.remote_list() ?? [] ),
				...( this.Widgets_removed_list()?.remote_list() ?? [] ),
			]
			const checked = new Set<string>()

			for( const container of containers ) {
				if( checked.has( container.link_str() ) ) continue
				checked.add( container.link_str() )
				if( container.link_str() == link.str ) continue
				if( !container.widgets().some( ( inner: $shm_hitalama_map_widget ) => inner.link().str == link.str ) ) continue

				container.Widgets(null)?.cut( link )
			}
		}

		@ $mol_action
		widget_restore( link: $giper_baza_link ) {
			const widget = this.widget_by_link(link)

			this.Widgets_list(null)?.add( link )
			this.Widgets_removed_list(null)?.cut( link )
		}

		@ $mol_mem
		search_statistics() {
			return this.Search_statistics()?.remote_list() ?? []
		}

		viewport_frames() {
			return this.Widgets_list()?.remote_list().filter( ( b: $shm_hitalama_map_widget ) => b.type() == 'viewport_frame' ) ?? []
		}

		@ $mol_mem
		components_by_name() {
			const widgets: Record< string, $shm_hitalama_map_widget > = {}
			this.Widgets_list()?.remote_list().forEach( ( b: $shm_hitalama_map_widget ) => {
				if( b.type() == 'component' ) {
					const name = b.Component()?.remote()?.class_name()
					if( !name ) return
					if( widgets[ name ]?.component().version() > b.component().version() ) return
					widgets[ name ] = b
				}
			} )
			return widgets
		}

		@ $mol_mem
		component_css() {
			return this.Widgets_list()?.remote_list().find( ( b: $shm_hitalama_map_widget ) => {
				if( b.type() == 'code_css' && b.Component()?.remote() ) return true
			} )
		}

		@ $mol_action
		search_statistics_cut( index: number ) {
			this.Search_statistics()?.wipe( index )
		}

		@ $mol_mem
		serialized() {
			return this.serialize()
		}

		@ $mol_mem
		get_transfer() {
			$mol_wire_solid()
			return $shm_hitalama_transfer_map.make({
				map: ()=> this
			})
		}

		@ $mol_mem
		get_restorer() {
			$mol_wire_solid()
			return $shm_hitalama_transfer_map_restorer.make({
				map: ()=> this,
			})
		}

		serialize(): $shm_hitalama_transfer_map_dump {
			const transfer = this.get_transfer()
			return transfer.serialize_map()
		}

		serialize_without_files(): $shm_hitalama_transfer_map_dump {
			const transfer = $shm_hitalama_transfer_map.make({
				map: ()=> this,
				include_files: ()=> false,
			})
			return transfer.serialize_map()
		}

		serialize_widgets( widgets: $shm_hitalama_map_widget[] ): $shm_hitalama_transfer_map_widgets_dump {
			const transfer = this.get_transfer()
			return transfer.serialize_widgets( widgets )
		}

		@ $mol_action
		deserialize_widgets( dto: $shm_hitalama_transfer_map_widgets_dump ) {
			const transfer = this.get_transfer()
			transfer.deserialize_widgets( dto )
		}

		@ $mol_action
		restore_widgets( dto: $shm_hitalama_transfer_map_widgets_dump ) {
			const restorer = this.get_restorer()
			restorer.deserialize_widgets( dto )
		}

		@ $mol_mem
		get_map_transfer() {
			$mol_wire_solid()
			return $shm_hitalama_map_transfer.make({
				map: ()=> this
			})
		}

		@ $mol_action
		deserialize( dto: $shm_hitalama_transfer_map_dump | any ) {
			if(
				dto
				&& typeof dto === 'object'
				&& !Array.isArray( dto )
				&& !('nodes' in dto)
				&& (
					Array.isArray( dto.blocks )
					|| Array.isArray( dto.widgets )
					|| Array.isArray( dto.tables )
					|| Array.isArray( dto.files )
				)
			) {
				const transfer = this.get_map_transfer()
				transfer.deserialize( dto )
				return
			}

			const transfer = this.get_transfer()
			transfer.deserialize_map( dto )
		}

		@ $mol_action
		restore( dto: $shm_hitalama_transfer_map_dump ) {
			const restorer = this.get_restorer()
			restorer.deserialize_map( dto )
		}
		
	}

}
